import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
@Injectable()
export class UserService {

  constructor(private http: HttpClient) { }
  saveInsuser(institution, name, mobile_number, email, role_id, role_type) {
    var formData = {
      'institution': institution,
      'name': name,
      'mobile_number': mobile_number,
      'email': email,
      'role_id': role_id,
      'role_type': role_type
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/create`, formData).pipe(map(user => {
      return user;
    }));
  }

  setting(slot,event, day,event_time ) {
    var formData = {
      'event': slot,
      'day': day,
      'event_slot':event,
      // 'event_time':event_time
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/settings/gate-close-create`, formData).pipe(map(user => {
      return user;
    }));
  }

  updatecolumn(event,rows,columndate ) {
    var formData = {
      'total_rows': rows,
      'event_slot': event,
      'event':columndate
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/settings/no-seats-create`,formData).pipe(map(user => {
      return user;
    }));
  }

  // columns(event, day, ) {
  //   var formData = {
  //     'event': event,
  //     'day': day,
  //   }
  //   return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/settings/gate-close-create`, formData).pipe(map(user => {
  //     return user;
  //   }));
  // }

  

  updateInsuser(id,institution, name, mobile_number, email, role_id, role_type) {
    var formData = {
      'institution': institution,
      'name': name,
      'mobile_number': mobile_number,
      'email': email,
      // 'role_id': role_id,
      // 'role_type': role_type
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/update/`+id, formData).pipe(map(user => {
      return user;
    }));
  }



  saveFooduser(name, mobile_number, email, role_id, role_type) {
    var formData = {
      'name': name,
      'mobile_number': mobile_number,
      'email': email,
      'role_id': role_id,
      'role_type': role_type
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/create-venue-users`, formData).pipe(map(user => {
      return user;
    }));
  }

  updateFooduser(id,name, mobile_number, email, role_id, role_type) {
    var formData = {
      'name': name,
      'mobile_number': mobile_number,
      'email': email,
      // 'role_id': role_id,
      // 'role_type': role_type
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/update-venue-users/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  getInsuser(page, search, role_type): Observable<any> {
    if (!search) {
      search = '';
    }
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin?role_type=` + role_type + '&page=' + page + '&search=' + search).pipe(map(user => user));
  }
  getInsuserfilter(page, search,institution, role_type): Observable<any> {
    if (!search) {
      search = '';
    }
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin?role_type=` + role_type + '&page=' + page + '&search=' + search+ '&institution=' + institution).pipe(map(user => user));
  }


  getInstitute(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/institute`).pipe(map(user => user));
  }

  uploadInsuser(file: File, id: any, type: any) {
    const formData: FormData = new FormData();
    if (file) {
      formData.append('file', file, file.name);
      formData.append('role_id', id);
      formData.append('role_type', type);
      return this.http
        .post<any>(
          ` ${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/create-excel`,
          formData
        )
        .pipe(
          map((user) => {
            return user;
          })
        );
    }

  }

  uploadFooduser(file: File, id: any, type: any) {
    const formData: FormData = new FormData();
    if (file) {
      formData.append('file', file, file.name);
      formData.append('role_id', id);
      formData.append('role_type', type);
      return this.http
        .post<any>(
          ` ${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/create-excel-venue-users`,
          formData
        )
        .pipe(
          map((user) => {
            return user;
          })
        );
    }
  }

  deleteUser(id: string) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/delete-users/` + id).pipe(map(user => {
        return user;
    }));
}

deleteAllUser(type: string) {
  var formData = {
    'type': type,
  }
  return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/delete-all-users` ,formData).pipe(map(user => {
      return user;
  }));
}

  getEvents(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/events`).pipe(map(user => user));
  }

  getcloselist(id): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/settings/gate-close/`+id).pipe(map(user => user));
  }

  getrowcount(event,id): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/settings/no-of-seats/`+id+'?event_slot='+event).pipe(map(user => user));
  }

  getGateCloseList(id,slotid): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/settings/gate-close/`+id+'?event_slot='+slotid).pipe(map(user => user));
  }

  seatallotment(id,date): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/seatings/generate-seats/`+date+'?event_slot='+id).pipe(map(user => user));
  }

  generateSeat(id): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/seatings/generate-seats/`+ id).pipe(map(user => user));
  }

  getVenueuser(page, search, role_type): Observable<any> {
    if (!search) {
      search = '';
    }
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/venue-food-users?role_type=` + role_type + '&page=' + page + '&search=' + search).pipe(map(user => user));
  }





  //judgement panel

  getJudgementPanel() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/judges/index`).pipe(map(user => user));
  }

  getJudgementPanelpage(page){
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/judges/index?page=`+page).pipe(map(user => user));
  }

  searchJudgementPanel(search){
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/judges/index?search=`+search).pipe(map(user => user));
  }

  teamcount(){
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/judges/team-count`).pipe(map(user => user));
  }

  individualcount(){
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/judges/team-count`).pipe(map(user => user));
  }

  getpoints(id){
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/judges/give-point/`+id).pipe(map(user => user));
  }
  getDashboardData(start_date,end_date){
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/custom-dashboard?start_date=`+ start_date + '&end_date=' + end_date).pipe(map(user => user));
 }
  //judgement-panel
  judgementPanel(search,page){
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/judges/dashboard?search=`+ search + '&page=' + page).pipe(map(user => user));
  }

  getJudgepoints(id){
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/judges/dashboard/give-point/`+id).pipe(map(user => user));
  }

  givepoints(reg_event_id, points) {
    var formData = {
      'reg_event_id': reg_event_id,
      //'judge': judge,
      'points': JSON.stringify(points)
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/judges/dashboard/give-point`, formData).pipe(map(user => {
      return user;
    }));
  }

 













  //WhiteLotus Project

   getNewbooking(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/getbookingdetails`).pipe(map(user => user));
   }

   //Amenities
    createAmenities(name, image): Observable<any>  {

      const formData: FormData = new FormData();
      formData.append('amenities', name);
      if (image) {
        formData.append('amenities_image', image, image.name);
      }
  
      return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/amenities`, formData).pipe(map(user => {
        return user;
      }));
    }

     updateAmenities(id,name, image): Observable<any>  {

      const formData: FormData = new FormData();
      formData.append('amenities', name);
      if (image) {
        formData.append('amenities_image', image, image.name);
      }
  
      return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/amenities/`+id, formData).pipe(map(user => {
        return user;
      }));
    }

    getAmenities(page): Observable<any> {
      return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/list-amenities?page=`+page).pipe(map(user => {
        return user;
      }));
    }

     deleteAmenities(id: string) {
      return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/amenities/` + id).pipe(map(user => {
         return user;
       }));
    }

    //Add Rate-type

    createRateType(name){
      var formData = {
        'name': name,
      }
      return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/rate/store`, formData).pipe(map(user => {
        return user;
      }));
    }

    updateRateType(id,name){
       var formData = {
        'name': name,
      }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/rate/` + id, formData).pipe(map(user => {
      return user;
    }));
    }

    DeleteRate(id: string) {
      return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/rate/` + id).pipe(map(user => {
        return user;
      }));
  }


    //Room Price
    getRoomType(): Observable<any> {
      return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/room-list`).pipe(map(user => user));
    }

    getRoomPrice(type,date): Observable<any> {
      return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/get-roomtypeprice/`+type+'?selected_date='+date).pipe(map(user => user));
    }

    getAvailableRooms(date):Observable<any> {
      return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/available-rooms?selected_date=`+ date).pipe(map(user => user));
    }

    UpdatePrice(price,date,type) {
      var formData = {
        'room_type': type,
        'amount': price,
        'date':date
      }
      return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/add_roomprice`, formData).pipe(map(user => {
         return user;
      }));
    }

    patchRoomprice(room_type,amount: number[],selected_date,extraOccupancy: number[],doubleOccupancy: number[]){
      var formData = {
       'room_type': room_type,
       'amount': JSON.stringify(amount),
       'extraOccupancy': JSON.stringify(extraOccupancy),
       'doubleOccupancy': JSON.stringify(doubleOccupancy),
       'selected_date':selected_date
      } 
      return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/setup-room-price`, formData).pipe(map(user => user));
    }

    updateroomprice(room:any){
      var formData = {
       'rooms': room,
      } 
      return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/setup-room-price`, formData).pipe(map(user => user));
    }

    roomavialabel(id,rooms,selected_date){
      var formData = {
        'room_type': id,
        'inventory_data': rooms,
        'selected_date':selected_date
      }
       return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/add-inventory`,formData).pipe(map(user => user));
     }

    //Add Room Type
    //  getRoomType(): Observable<any> {
    //    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/room-list`).pipe(map(user => user));
    //  }

    getRate(page): Observable<any> {
      return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/rate?page=`+page).pipe(map(user => user));
    }

    listamenities(): Observable<any> {
       return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/list-amenities`).pipe(map(user => user));
    }

    addRoomType(room_type,price,rate_type,amenities,description,no_occupancy,single_occupancy,extra_occupancy,no_of_infants:any,images: File[]){
      const formData: FormData = new FormData();
      formData.append('room_type', room_type);
      formData.append('price', price);
      formData.append('rate_type', rate_type);
      formData.append('description', description);
      formData.append('no_of_occupancy', no_occupancy);
      formData.append('extra_occupancy', extra_occupancy);
      formData.append('single_occupancy_price', single_occupancy);
      formData.append('no_of_infants',no_of_infants)
      // formData.append('roomCapacity', roomCapacity);
       images && images.map(image => {
        formData.append('room_image', image, image.name);
      });
      // images && images.map(image => {
      //  const options = {
      //    type: image.type 
      //  };
      //  const blob = new Blob([image], options); 
      //  formData.append('room_image', blob, image.name);
      // });
      amenities && amenities.map(amenities => {
        formData.append('amenities', amenities);
      });
  
      return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/rooms-type/store`, formData).pipe(map(user => {
        return user;
      }));
    }

   DeleteRoomtype(id: string) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/rooms-type/` + id).pipe(map(user => {
      return user;
    }));
  }

  updateRoomType(id,room_type,price,rate_type,amenities,description,no_occupancy,single_occupancy,extra_occupancy,no_of_infants:any,images: File[]){
    const formData: FormData = new FormData();
    formData.append('room_type', room_type);
    formData.append('price', price);
    formData.append('rate_type', rate_type);
    // formData.append('amenities',amenities);
    formData.append('description', description);
    formData.append('no_of_occupancy', no_occupancy);
    formData.append('extra_occupancy', extra_occupancy);
    formData.append('single_occupancy_price', single_occupancy);
    formData.append('no_of_infants',no_of_infants)
    // formData.append('roomCapacity', roomCapacity);
      images && images.map(image => {
      formData.append('room_image', image, image.name);
    });
     amenities && amenities.map(amenities => {
      formData.append('amenities', amenities);
    });

    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/rooms-type/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  
  //Room Master (count)
    getRooms(): Observable<any> {
      return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/rooms`).pipe(map(user => user));
    }

    saveRooms(room_number: any,room_type: any,) {
    var formData = {
      'total_rooms': room_number,
      'room_type': room_type
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/rooms/store`, formData).pipe(map(user => {
      return user;
    }));
  }

  updateRooms(id,room_number: any,room_type: any,) {
    var formData = {
      'total_rooms': room_number,
      'room_type': room_type
    }
   return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/rooms/store`, formData).pipe(map(user => {
      return user;
    }));
  }

   DeleteRoomCount(id: string) {
      return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/rooms/` + id).pipe(map(user => {
        return user;
      }));
  }

  //Block Rooms
  getBlock(page): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/blocks?page=`+page).pipe(map(user => user));
  }

   updateroomBlock(roomtype,roomno: any, fromdate,todate,status: any,uniqueId) {    
    var formData = {
      'room_type':roomtype,
      'total_rooms': roomno,
      'from_date':fromdate,
      'to_date':todate,
      'status':status,
      'uniqueId':uniqueId
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/blockmultiplerooms`, formData).pipe(map(user => {
      return user;
    }));
  }

  addroomblock(roomtype,roomno: any, fromdate, todate, status: any) {
    var formData = {
      'room_type':roomtype,
      'total_rooms': roomno,
      'from_date':fromdate,
      'to_date':todate,
      'status':status,
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/blockmultiplerooms`, formData).pipe(map(user => {
      return user;
    }));

  }

  //New Booking

  getBookingDetails(page,search,arrival_date,departure_date,sortField): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/getbookingdetails?page=` +page + '&search=' + search + '&arrival_date=' + arrival_date + '&departure_date=' + departure_date + '&sortField='+sortField).pipe(map(user => user));
  }

  cancelBooking(id) {
  var formData = {
    'status':13,
    'booking_status':13,
    bookingId:id
  }
  return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/cancel_status` , formData).pipe(map(user => {
    return user;
  }));
 }

 getGuestHistory(page,search,arrival_date,departure_date){
  return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/guesthistory?page=` + page + '&search=' + search + '&arrival_date=' + arrival_date + '&departure_date=' + departure_date).pipe(map(user => user));
}

getCancelledBookings(page,search,arrival_date,departure_date){
  return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/cancelled?page=` + page + '&search=' + search + '&arrival_date=' + arrival_date + '&departure_date=' + departure_date).pipe(map(user => user));
}

  getpaymentQueriesLists(page, search, arrival_date, departure_date) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/getPaidBookings?page=` + page + '&search=' + search + '&arrival_date=' + arrival_date + '&departure_date=' + departure_date).pipe(map(user => user));
  }

  updateQueryLists(payload: any) {
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/users/verify-callback`, payload).pipe(map(response => {
      return response;
    })
    );
  }
  getDashboardchk(date: any): Observable<any> {
      var formData = {'selected_date':date}
       return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/get-checkincount?`+$.param(formData)).pipe(map(user => user));
   }
  //dashboard


   userDashboard(selected_date){
      return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard-count?start_date=`+selected_date).pipe(map(user => user));
   }

   dashboardCounts(selected_date){
     return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard?start_date=`+selected_date).pipe(map(user => user));
   }

  todayCounts(selected_date){
     return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/today-dashboard?start_date=`+selected_date).pipe(map(user => user));
  }

  yesterdayCounts(selected_date){
     return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/yesterday-dashboard?start_date=`+selected_date).pipe(map(user => user));
  }

  last7daysCounts(selected_date){
     return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/last-7-dashboard?start_date=`+selected_date).pipe(map(user => user));
  }

   last30daysCounts(selected_date){
     return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/last-30-dashboard?start_date=`+selected_date).pipe(map(user => user));
  }

  lastMonthCounts(selected_date){
     return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/last-month-dashboard?start_date=`+selected_date).pipe(map(user => user));
  }


 // Download Pdf Invoice

 downloadBookingInvoice(id:any){
  const file =this.http.get<Blob>(`${environment.apiUrl}${environment.apiPrefix}/admin/bookingdetailsdownload?uniqueid=` + id, { responseType: 'blob' as 'json' }).pipe(map(user => {
    return user
  }));
  return file;
}
downloadBookingInvoice1(id:any){
  return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/bookingdetailsdownload?uniqueid=` + id).pipe(map(user => {
    return user
  }));
}

downloadPrevBookingInvoice(id:any){
  const file =this.http.get<Blob>(`${environment.apiUrl}${environment.apiPrefix}/admin/previousbookingdetailsdownload?uniqueid=` + id, { responseType: 'blob' as 'json' }).pipe(map(user => {
    return user
  }));
  return file;
}
downloadPrevBookingInvoice1(id:any){
  return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/previousbookingdetailsdownload?uniqueid=` + id).pipe(map(user => {
    return user
  }));
}

downloadCancelledBookingInvoice(id:any){
  const file =this.http.get<Blob>(`${environment.apiUrl}${environment.apiPrefix}/admin/cancelledbookingdetailsdownload?uniqueid=`+ id, { responseType: 'blob' as 'json' }).pipe(map(user => {
    return user
  }));
  return file;
}
downloadCancelledBookingInvoice1(id:any){
  return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/cancelledbookingdetailsdownload?uniqueid=`+ id).pipe(map(user => {
    return user
  }));
}


    //download excel sheets
    downloadNewBookExcel(arrival_date:any,departure_date:any,sortField:any){
      const file =this.http.get<Blob>(`${environment.apiUrl}${environment.apiPrefix}/admin/bookingdetailsexceldownload?arrival_date=` + arrival_date + '&departure_date=' + departure_date +'&sortField=' + sortField, { responseType: 'blob' as 'json' }).pipe(map(user => {
          return user
      }));
      return file;
  }

  downloadPrevBookExcel(arrival_date:any,departure_date:any){
      const file =this.http.get<Blob>(`${environment.apiUrl}${environment.apiPrefix}/admin/previousbookingexceldownload?arrival_date=` + arrival_date + '&departure_date=' + departure_date , { responseType: 'blob' as 'json' }).pipe(map(user => {
          return user
      }));
      return file;
  }

  downloadCancelledBookExcel(arrival_date:any,departure_date:any){
      const file =this.http.get<Blob>(`${environment.apiUrl}${environment.apiPrefix}/admin/cancelledbookingexceldownload?arrival_date=` + arrival_date + '&departure_date=' + departure_date , { responseType: 'blob' as 'json' }).pipe(map(user => {
          return user
      }));
      return file;
  }
    // Room Price - New api
    getRoomlistLatest(arrival_date,departure_date){
      return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/room-list?arrival_date=`+ arrival_date + '&departure_date=' + departure_date).pipe(map(user => user));
   }

   getRoomPriceLatest(id,arrival_date,departure_date): Observable<any> {
      return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/get-roomtypeprice/`+id + '?arrival_date=' + arrival_date + '&departure_date=' + departure_date).pipe(map(user => user));
    }

    inventorybulkUpload(fromDate,toDate,inventoryData: any[]): Observable<any> {
      var payload = {
        inventoryData: inventoryData
      };
    
      return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/inventory-bulk-upload?fromDate=` + fromDate + '&toDate=' + toDate, payload).pipe(map(user => user));
    }

    roompricebulkUpload(fromDate,toDate,rooms: any[]): Observable<any> {
      var payload = {
        rooms: rooms
      };
    
      return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/bulk-upload-roomprice?fromDate=` + fromDate + '&toDate=' + toDate, payload).pipe(map(user => user));
    }
}
